import HowWeBuildProductCard from './HowWeBuildProductCard';

export default HowWeBuildProductCard;
